//Swiper Library
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-cards";
import "../CommonCSS/HomeSwiper.css";
import { EffectCards } from "swiper/modules";

import profilePhoto from "../../assets/Images/Jitesh-bg.png";
import webGif from "../../assets/Gifs/web.gif";
import appGif from "../../assets/Gifs/app.gif";
import freelancerGif from "../../assets/Gifs/freelancer.jpeg";

export default function HomeSwiper() {
  return (
    <Swiper
      effect={"cards"}
      grabCursor={true}
      modules={[EffectCards]}
      className="mySwiper"
    >
      <SwiperSlide>
        <h5 className="uppercase font-normal text-6xl text-white">Hello!</h5>
      </SwiperSlide>
      <SwiperSlide>
        <div className="flex flex-col justify-center items-center gap-10">
          <div>
            <h3 className="text-2xl md:text-4xl font-semibold">
              I'm <span className="text-[#FFBD39]">Jitesh Sharma </span>
            </h3>
            <p className="text-lg text-center">(Graduated @ <span className="text-[#FFBD39] text-xl">2020-2023</span> )</p>
          </div>
          <img
            src={profilePhoto}
            alt="profile"
            className="w-[80%] max-h-[500px] rounded-2xl"
          />
        </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className="flex flex-col justify-center items-center gap-10">
          <div>
            <h3 className="text-2xl md:text-4xl font-semibold">
              I'm <span className="text-[#FFBD39]">Mobile APP Developer </span>
            </h3>
            <p className="text-lg text-center">(APP Developer @ <span className="text-[#FFBD39] text-xl">1 Year</span> )</p>
          </div>
          <img
            src={appGif}
            alt="appImage"
            className="w-[80%] h-[80%] rounded-2xl"
          />
      </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className="flex flex-col justify-center items-center gap-10">
          <div>
            <h3 className="text-2xl md:text-4xl font-semibold">
              I'm <span className="text-[#FFBD39]">MERN STACK Developer </span>
            </h3>
            <p className="text-center">(MERN Developer @ <span className="text-[#FFBD39] text-xl">3 Months</span> )</p>
          </div>
          <img
            src={webGif}
            alt="webImage"
            className="w-[80%] h-[80%] rounded-2xl"
          />
      </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className="flex flex-col justify-center items-center gap-10">
          <div>
            <h3 className="text-2xl md:text-4xl font-semibold">
              I'm <span className="text-[#FFBD39]">Freelancer </span>
            </h3>
            <p className="text-lg text-center">(Freelancer @ <span className="text-[#FFBD39] text-xl">2 Months</span> )</p>
          </div>
          <img
            src={freelancerGif}
            alt="freelanceImage"
            className="w-[55%] h-[55%] rounded-2xl"
          />
        </div>
      </SwiperSlide>
    </Swiper>
  );
}
